import {
  GET_LIST_HOPDONGDELETE,
  GET_LIST_HOPDONGDELETE_SUCCESS,
  GET_LIST_HOPDONGDELETE_FAILURE,
  UPDATE_SEARCHTDATA_HOPDONGDELETE,
} from "./actionTypes";

export const getListHopDongDelete = (dataSearch) => ({
  type: GET_LIST_HOPDONGDELETE,
  dataSearch,
});
export const getListHopDongDeleteSuccess = (data) => ({
  type: GET_LIST_HOPDONGDELETE_SUCCESS,
  payload: data,
});
export const getListHopDongDeleteFailure = (dataSearch) => ({
  type: GET_LIST_HOPDONGDELETE_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_HOPDONGDELETE,
  payload: data,
});
